import { useEffect, useState } from "preact/hooks";
import type { Upload } from "@campaign-media/shared";
import { columnCountForWidth, distributeColumns } from "../masonry.js";

interface Props { items: Upload[]; urlFor: (path: string) => string; onTileClick: (i: number) => void; }

function useColumnCount(): number {
  const [count, setCount] = useState(() => columnCountForWidth(window.innerWidth));
  useEffect(() => {
    const onResize = () => setCount(columnCountForWidth(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return count;
}

export function MasonryGrid({ items, urlFor, onTileClick }: Props) {
  const columnCount = useColumnCount();
  const indexed = items.map((u, i) => ({ u, i }));
  const columns = distributeColumns(indexed, columnCount);

  return (
    <div class="grid">
      {columns.map((col, colIdx) => (
        <div class="col" key={colIdx}>
          {col.map(({ u, i }) => (
            <div class="tile" key={u.id} onClick={() => onTileClick(i)}>
              {u.storage_path && <img src={urlFor(u.storage_path)} loading="lazy" alt="" />}
              {u.caption && <div class="caption">{u.caption}</div>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
